/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesLocationStates.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for State Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, May 13, 2019 - 04:47:35 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      05/13/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const LocationStateList = Loadable({
    loader: () => import('../containers/LocationStates/LocationStateListContainer'),
    loading: Loading,
});

export const LocationStateForm = Loadable({
    loader: () => import('../containers/LocationStates/LocationStateEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesLocationStates.js